/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth/route'
import { Route as AppRouteImport } from './routes/_app/route'
import { Route as AppIndexImport } from './routes/_app/index'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AppSettingsRouteImport } from './routes/_app/settings/route'
import { Route as AppOutletRouteImport } from './routes/_app/outlet/route'
import { Route as AppSettingsIndexImport } from './routes/_app/settings/index'
import { Route as AppSaleIndexImport } from './routes/_app/sale/index'
import { Route as AppReportIndexImport } from './routes/_app/report/index'
import { Route as AppProfileIndexImport } from './routes/_app/profile/index'
import { Route as AppProductIndexImport } from './routes/_app/product/index'
import { Route as AppOutletIndexImport } from './routes/_app/outlet/index'
import { Route as AppReportCashFlowImport } from './routes/_app/report/cash-flow'
import { Route as AppProductCreateImport } from './routes/_app/product/create'
import { Route as AppInventorySplatImport } from './routes/_app/inventory/$'
import { Route as AppOutletStaffRouteImport } from './routes/_app/outlet/staff/route'
import { Route as AppOutletPosRouteImport } from './routes/_app/outlet/pos/route'
import { Route as AppSettingsUserIndexImport } from './routes/_app/settings/user/index'
import { Route as AppSettingsTeamIndexImport } from './routes/_app/settings/team/index'
import { Route as AppSettingsOutletIndexImport } from './routes/_app/settings/outlet/index'
import { Route as AppReportSalesIndexImport } from './routes/_app/report/sales/index'
import { Route as AppProductCategoryIndexImport } from './routes/_app/product/category/index'
import { Route as AppProductIdIndexImport } from './routes/_app/product/$id.index'
import { Route as AppOutletStaffIndexImport } from './routes/_app/outlet/staff/index'
import { Route as AppOutletSalesChannelIndexImport } from './routes/_app/outlet/sales-channel/index'
import { Route as AppOutletPosIndexImport } from './routes/_app/outlet/pos/index'
import { Route as AppOutletPaymentIndexImport } from './routes/_app/outlet/payment/index'
import { Route as AppInventoryUnitIndexImport } from './routes/_app/inventory/unit/index'
import { Route as AppInventorySupplierIndexImport } from './routes/_app/inventory/supplier/index'
import { Route as AppInventoryStockIndexImport } from './routes/_app/inventory/stock/index'
import { Route as AppInventoryPoIndexImport } from './routes/_app/inventory/po/index'
import { Route as AppInventoryMasterIndexImport } from './routes/_app/inventory/master/index'
import { Route as AppInventoryCategoryIndexImport } from './routes/_app/inventory/category/index'
import { Route as AppSettingsUserCreateImport } from './routes/_app/settings/user/create'
import { Route as AppSettingsTeamCreateImport } from './routes/_app/settings/team/create'
import { Route as AppSettingsOutletCreateImport } from './routes/_app/settings/outlet/create'
import { Route as AppSettingsOutletIdImport } from './routes/_app/settings/outlet/$id'
import { Route as AppProductCategoryCreateImport } from './routes/_app/product/category/create'
import { Route as AppProductIdUpdateImport } from './routes/_app/product/$id.update'
import { Route as AppProductIdRecipeImport } from './routes/_app/product/$id.recipe'
import { Route as AppOutletStaffAddImport } from './routes/_app/outlet/staff/add'
import { Route as AppOutletPosCreateImport } from './routes/_app/outlet/pos/create'
import { Route as AppOutletPosPosidImport } from './routes/_app/outlet/pos/$posid'
import { Route as AppInventoryUnitCreateImport } from './routes/_app/inventory/unit/create'
import { Route as AppInventoryUnitIdImport } from './routes/_app/inventory/unit/$id'
import { Route as AppInventorySupplierCreateImport } from './routes/_app/inventory/supplier/create'
import { Route as AppInventoryPoCreateImport } from './routes/_app/inventory/po/create'
import { Route as AppInventoryMasterCreateImport } from './routes/_app/inventory/master/create'
import { Route as AppInventoryCategoryCreateImport } from './routes/_app/inventory/category/create'
import { Route as AppSettingsUserIdIndexImport } from './routes/_app/settings/user/$id.index'
import { Route as AppInventorySupplierIdIndexImport } from './routes/_app/inventory/supplier/$id.index'
import { Route as AppInventoryMasterIdIndexImport } from './routes/_app/inventory/master/$id.index'
import { Route as AppInventoryCategoryIdIndexImport } from './routes/_app/inventory/category/$id.index'
import { Route as AppSettingsUserIdEditImport } from './routes/_app/settings/user/$id.edit'
import { Route as AppSettingsTeamIdEditImport } from './routes/_app/settings/team/$id.edit'
import { Route as AppProductCategoryIdUpdateImport } from './routes/_app/product/category/$id.update'
import { Route as AppInventorySupplierIdEditImport } from './routes/_app/inventory/supplier/$id.edit'
import { Route as AppInventoryMasterIdRecipeImport } from './routes/_app/inventory/master/$id.recipe'
import { Route as AppInventoryMasterIdEditImport } from './routes/_app/inventory/master/$id.edit'
import { Route as AppInventoryCategoryIdEditImport } from './routes/_app/inventory/category/$id.edit'

// Create/Update Routes

const AuthRouteRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRouteRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AppSettingsRouteRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOutletRouteRoute = AppOutletRouteImport.update({
  id: '/outlet',
  path: '/outlet',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSettingsIndexRoute = AppSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSaleIndexRoute = AppSaleIndexImport.update({
  id: '/sale/',
  path: '/sale/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppReportIndexRoute = AppReportIndexImport.update({
  id: '/report/',
  path: '/report/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProfileIndexRoute = AppProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProductIndexRoute = AppProductIndexImport.update({
  id: '/product/',
  path: '/product/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOutletIndexRoute = AppOutletIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOutletRouteRoute,
} as any)

const AppReportCashFlowRoute = AppReportCashFlowImport.update({
  id: '/report/cash-flow',
  path: '/report/cash-flow',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProductCreateRoute = AppProductCreateImport.update({
  id: '/product/create',
  path: '/product/create',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventorySplatRoute = AppInventorySplatImport.update({
  id: '/inventory/$',
  path: '/inventory/$',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOutletStaffRouteRoute = AppOutletStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppOutletRouteRoute,
} as any)

const AppOutletPosRouteRoute = AppOutletPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => AppOutletRouteRoute,
} as any)

const AppSettingsUserIndexRoute = AppSettingsUserIndexImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsTeamIndexRoute = AppSettingsTeamIndexImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsOutletIndexRoute = AppSettingsOutletIndexImport.update({
  id: '/outlet/',
  path: '/outlet/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppReportSalesIndexRoute = AppReportSalesIndexImport.update({
  id: '/report/sales/',
  path: '/report/sales/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProductCategoryIndexRoute = AppProductCategoryIndexImport.update({
  id: '/product/category/',
  path: '/product/category/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProductIdIndexRoute = AppProductIdIndexImport.update({
  id: '/product/$id/',
  path: '/product/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOutletStaffIndexRoute = AppOutletStaffIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOutletStaffRouteRoute,
} as any)

const AppOutletSalesChannelIndexRoute = AppOutletSalesChannelIndexImport.update(
  {
    id: '/sales-channel/',
    path: '/sales-channel/',
    getParentRoute: () => AppOutletRouteRoute,
  } as any,
)

const AppOutletPosIndexRoute = AppOutletPosIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOutletPosRouteRoute,
} as any)

const AppOutletPaymentIndexRoute = AppOutletPaymentIndexImport.update({
  id: '/payment/',
  path: '/payment/',
  getParentRoute: () => AppOutletRouteRoute,
} as any)

const AppInventoryUnitIndexRoute = AppInventoryUnitIndexImport.update({
  id: '/inventory/unit/',
  path: '/inventory/unit/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventorySupplierIndexRoute = AppInventorySupplierIndexImport.update({
  id: '/inventory/supplier/',
  path: '/inventory/supplier/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryStockIndexRoute = AppInventoryStockIndexImport.update({
  id: '/inventory/stock/',
  path: '/inventory/stock/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryPoIndexRoute = AppInventoryPoIndexImport.update({
  id: '/inventory/po/',
  path: '/inventory/po/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryMasterIndexRoute = AppInventoryMasterIndexImport.update({
  id: '/inventory/master/',
  path: '/inventory/master/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryCategoryIndexRoute = AppInventoryCategoryIndexImport.update({
  id: '/inventory/category/',
  path: '/inventory/category/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSettingsUserCreateRoute = AppSettingsUserCreateImport.update({
  id: '/user/create',
  path: '/user/create',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsTeamCreateRoute = AppSettingsTeamCreateImport.update({
  id: '/team/create',
  path: '/team/create',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsOutletCreateRoute = AppSettingsOutletCreateImport.update({
  id: '/outlet/create',
  path: '/outlet/create',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsOutletIdRoute = AppSettingsOutletIdImport.update({
  id: '/outlet/$id',
  path: '/outlet/$id',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppProductCategoryCreateRoute = AppProductCategoryCreateImport.update({
  id: '/product/category/create',
  path: '/product/category/create',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProductIdUpdateRoute = AppProductIdUpdateImport.update({
  id: '/product/$id/update',
  path: '/product/$id/update',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProductIdRecipeRoute = AppProductIdRecipeImport.update({
  id: '/product/$id/recipe',
  path: '/product/$id/recipe',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppOutletStaffAddRoute = AppOutletStaffAddImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AppOutletStaffRouteRoute,
} as any)

const AppOutletPosCreateRoute = AppOutletPosCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppOutletPosRouteRoute,
} as any)

const AppOutletPosPosidRoute = AppOutletPosPosidImport.update({
  id: '/$posid',
  path: '/$posid',
  getParentRoute: () => AppOutletPosRouteRoute,
} as any)

const AppInventoryUnitCreateRoute = AppInventoryUnitCreateImport.update({
  id: '/inventory/unit/create',
  path: '/inventory/unit/create',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryUnitIdRoute = AppInventoryUnitIdImport.update({
  id: '/inventory/unit/$id',
  path: '/inventory/unit/$id',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventorySupplierCreateRoute = AppInventorySupplierCreateImport.update(
  {
    id: '/inventory/supplier/create',
    path: '/inventory/supplier/create',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

const AppInventoryPoCreateRoute = AppInventoryPoCreateImport.update({
  id: '/inventory/po/create',
  path: '/inventory/po/create',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryMasterCreateRoute = AppInventoryMasterCreateImport.update({
  id: '/inventory/master/create',
  path: '/inventory/master/create',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryCategoryCreateRoute = AppInventoryCategoryCreateImport.update(
  {
    id: '/inventory/category/create',
    path: '/inventory/category/create',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

const AppSettingsUserIdIndexRoute = AppSettingsUserIdIndexImport.update({
  id: '/user/$id/',
  path: '/user/$id/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppInventorySupplierIdIndexRoute =
  AppInventorySupplierIdIndexImport.update({
    id: '/inventory/supplier/$id/',
    path: '/inventory/supplier/$id/',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppInventoryMasterIdIndexRoute = AppInventoryMasterIdIndexImport.update({
  id: '/inventory/master/$id/',
  path: '/inventory/master/$id/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryCategoryIdIndexRoute =
  AppInventoryCategoryIdIndexImport.update({
    id: '/inventory/category/$id/',
    path: '/inventory/category/$id/',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppSettingsUserIdEditRoute = AppSettingsUserIdEditImport.update({
  id: '/user/$id/edit',
  path: '/user/$id/edit',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsTeamIdEditRoute = AppSettingsTeamIdEditImport.update({
  id: '/team/$id/edit',
  path: '/team/$id/edit',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppProductCategoryIdUpdateRoute = AppProductCategoryIdUpdateImport.update(
  {
    id: '/product/category/$id/update',
    path: '/product/category/$id/update',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

const AppInventorySupplierIdEditRoute = AppInventorySupplierIdEditImport.update(
  {
    id: '/inventory/supplier/$id/edit',
    path: '/inventory/supplier/$id/edit',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

const AppInventoryMasterIdRecipeRoute = AppInventoryMasterIdRecipeImport.update(
  {
    id: '/inventory/master/$id/recipe',
    path: '/inventory/master/$id/recipe',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

const AppInventoryMasterIdEditRoute = AppInventoryMasterIdEditImport.update({
  id: '/inventory/master/$id/edit',
  path: '/inventory/master/$id/edit',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInventoryCategoryIdEditRoute = AppInventoryCategoryIdEditImport.update(
  {
    id: '/inventory/category/$id/edit',
    path: '/inventory/category/$id/edit',
    getParentRoute: () => AppRouteRoute,
  } as any,
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/_app/outlet': {
      id: '/_app/outlet'
      path: '/outlet'
      fullPath: '/outlet'
      preLoaderRoute: typeof AppOutletRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/outlet/pos': {
      id: '/_app/outlet/pos'
      path: '/pos'
      fullPath: '/outlet/pos'
      preLoaderRoute: typeof AppOutletPosRouteImport
      parentRoute: typeof AppOutletRouteImport
    }
    '/_app/outlet/staff': {
      id: '/_app/outlet/staff'
      path: '/staff'
      fullPath: '/outlet/staff'
      preLoaderRoute: typeof AppOutletStaffRouteImport
      parentRoute: typeof AppOutletRouteImport
    }
    '/_app/inventory/$': {
      id: '/_app/inventory/$'
      path: '/inventory/$'
      fullPath: '/inventory/$'
      preLoaderRoute: typeof AppInventorySplatImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/product/create': {
      id: '/_app/product/create'
      path: '/product/create'
      fullPath: '/product/create'
      preLoaderRoute: typeof AppProductCreateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/report/cash-flow': {
      id: '/_app/report/cash-flow'
      path: '/report/cash-flow'
      fullPath: '/report/cash-flow'
      preLoaderRoute: typeof AppReportCashFlowImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/outlet/': {
      id: '/_app/outlet/'
      path: '/'
      fullPath: '/outlet/'
      preLoaderRoute: typeof AppOutletIndexImport
      parentRoute: typeof AppOutletRouteImport
    }
    '/_app/product/': {
      id: '/_app/product/'
      path: '/product'
      fullPath: '/product'
      preLoaderRoute: typeof AppProductIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/report/': {
      id: '/_app/report/'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AppReportIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/sale/': {
      id: '/_app/sale/'
      path: '/sale'
      fullPath: '/sale'
      preLoaderRoute: typeof AppSaleIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/inventory/category/create': {
      id: '/_app/inventory/category/create'
      path: '/inventory/category/create'
      fullPath: '/inventory/category/create'
      preLoaderRoute: typeof AppInventoryCategoryCreateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/master/create': {
      id: '/_app/inventory/master/create'
      path: '/inventory/master/create'
      fullPath: '/inventory/master/create'
      preLoaderRoute: typeof AppInventoryMasterCreateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/po/create': {
      id: '/_app/inventory/po/create'
      path: '/inventory/po/create'
      fullPath: '/inventory/po/create'
      preLoaderRoute: typeof AppInventoryPoCreateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/supplier/create': {
      id: '/_app/inventory/supplier/create'
      path: '/inventory/supplier/create'
      fullPath: '/inventory/supplier/create'
      preLoaderRoute: typeof AppInventorySupplierCreateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/unit/$id': {
      id: '/_app/inventory/unit/$id'
      path: '/inventory/unit/$id'
      fullPath: '/inventory/unit/$id'
      preLoaderRoute: typeof AppInventoryUnitIdImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/unit/create': {
      id: '/_app/inventory/unit/create'
      path: '/inventory/unit/create'
      fullPath: '/inventory/unit/create'
      preLoaderRoute: typeof AppInventoryUnitCreateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/outlet/pos/$posid': {
      id: '/_app/outlet/pos/$posid'
      path: '/$posid'
      fullPath: '/outlet/pos/$posid'
      preLoaderRoute: typeof AppOutletPosPosidImport
      parentRoute: typeof AppOutletPosRouteImport
    }
    '/_app/outlet/pos/create': {
      id: '/_app/outlet/pos/create'
      path: '/create'
      fullPath: '/outlet/pos/create'
      preLoaderRoute: typeof AppOutletPosCreateImport
      parentRoute: typeof AppOutletPosRouteImport
    }
    '/_app/outlet/staff/add': {
      id: '/_app/outlet/staff/add'
      path: '/add'
      fullPath: '/outlet/staff/add'
      preLoaderRoute: typeof AppOutletStaffAddImport
      parentRoute: typeof AppOutletStaffRouteImport
    }
    '/_app/product/$id/recipe': {
      id: '/_app/product/$id/recipe'
      path: '/product/$id/recipe'
      fullPath: '/product/$id/recipe'
      preLoaderRoute: typeof AppProductIdRecipeImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/product/$id/update': {
      id: '/_app/product/$id/update'
      path: '/product/$id/update'
      fullPath: '/product/$id/update'
      preLoaderRoute: typeof AppProductIdUpdateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/product/category/create': {
      id: '/_app/product/category/create'
      path: '/product/category/create'
      fullPath: '/product/category/create'
      preLoaderRoute: typeof AppProductCategoryCreateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/settings/outlet/$id': {
      id: '/_app/settings/outlet/$id'
      path: '/outlet/$id'
      fullPath: '/settings/outlet/$id'
      preLoaderRoute: typeof AppSettingsOutletIdImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/outlet/create': {
      id: '/_app/settings/outlet/create'
      path: '/outlet/create'
      fullPath: '/settings/outlet/create'
      preLoaderRoute: typeof AppSettingsOutletCreateImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/team/create': {
      id: '/_app/settings/team/create'
      path: '/team/create'
      fullPath: '/settings/team/create'
      preLoaderRoute: typeof AppSettingsTeamCreateImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/user/create': {
      id: '/_app/settings/user/create'
      path: '/user/create'
      fullPath: '/settings/user/create'
      preLoaderRoute: typeof AppSettingsUserCreateImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/inventory/category/': {
      id: '/_app/inventory/category/'
      path: '/inventory/category'
      fullPath: '/inventory/category'
      preLoaderRoute: typeof AppInventoryCategoryIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/master/': {
      id: '/_app/inventory/master/'
      path: '/inventory/master'
      fullPath: '/inventory/master'
      preLoaderRoute: typeof AppInventoryMasterIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/po/': {
      id: '/_app/inventory/po/'
      path: '/inventory/po'
      fullPath: '/inventory/po'
      preLoaderRoute: typeof AppInventoryPoIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/stock/': {
      id: '/_app/inventory/stock/'
      path: '/inventory/stock'
      fullPath: '/inventory/stock'
      preLoaderRoute: typeof AppInventoryStockIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/supplier/': {
      id: '/_app/inventory/supplier/'
      path: '/inventory/supplier'
      fullPath: '/inventory/supplier'
      preLoaderRoute: typeof AppInventorySupplierIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/unit/': {
      id: '/_app/inventory/unit/'
      path: '/inventory/unit'
      fullPath: '/inventory/unit'
      preLoaderRoute: typeof AppInventoryUnitIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/outlet/payment/': {
      id: '/_app/outlet/payment/'
      path: '/payment'
      fullPath: '/outlet/payment'
      preLoaderRoute: typeof AppOutletPaymentIndexImport
      parentRoute: typeof AppOutletRouteImport
    }
    '/_app/outlet/pos/': {
      id: '/_app/outlet/pos/'
      path: '/'
      fullPath: '/outlet/pos/'
      preLoaderRoute: typeof AppOutletPosIndexImport
      parentRoute: typeof AppOutletPosRouteImport
    }
    '/_app/outlet/sales-channel/': {
      id: '/_app/outlet/sales-channel/'
      path: '/sales-channel'
      fullPath: '/outlet/sales-channel'
      preLoaderRoute: typeof AppOutletSalesChannelIndexImport
      parentRoute: typeof AppOutletRouteImport
    }
    '/_app/outlet/staff/': {
      id: '/_app/outlet/staff/'
      path: '/'
      fullPath: '/outlet/staff/'
      preLoaderRoute: typeof AppOutletStaffIndexImport
      parentRoute: typeof AppOutletStaffRouteImport
    }
    '/_app/product/$id/': {
      id: '/_app/product/$id/'
      path: '/product/$id'
      fullPath: '/product/$id'
      preLoaderRoute: typeof AppProductIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/product/category/': {
      id: '/_app/product/category/'
      path: '/product/category'
      fullPath: '/product/category'
      preLoaderRoute: typeof AppProductCategoryIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/report/sales/': {
      id: '/_app/report/sales/'
      path: '/report/sales'
      fullPath: '/report/sales'
      preLoaderRoute: typeof AppReportSalesIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/settings/outlet/': {
      id: '/_app/settings/outlet/'
      path: '/outlet'
      fullPath: '/settings/outlet'
      preLoaderRoute: typeof AppSettingsOutletIndexImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/team/': {
      id: '/_app/settings/team/'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamIndexImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/user/': {
      id: '/_app/settings/user/'
      path: '/user'
      fullPath: '/settings/user'
      preLoaderRoute: typeof AppSettingsUserIndexImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/inventory/category/$id/edit': {
      id: '/_app/inventory/category/$id/edit'
      path: '/inventory/category/$id/edit'
      fullPath: '/inventory/category/$id/edit'
      preLoaderRoute: typeof AppInventoryCategoryIdEditImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/master/$id/edit': {
      id: '/_app/inventory/master/$id/edit'
      path: '/inventory/master/$id/edit'
      fullPath: '/inventory/master/$id/edit'
      preLoaderRoute: typeof AppInventoryMasterIdEditImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/master/$id/recipe': {
      id: '/_app/inventory/master/$id/recipe'
      path: '/inventory/master/$id/recipe'
      fullPath: '/inventory/master/$id/recipe'
      preLoaderRoute: typeof AppInventoryMasterIdRecipeImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/supplier/$id/edit': {
      id: '/_app/inventory/supplier/$id/edit'
      path: '/inventory/supplier/$id/edit'
      fullPath: '/inventory/supplier/$id/edit'
      preLoaderRoute: typeof AppInventorySupplierIdEditImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/product/category/$id/update': {
      id: '/_app/product/category/$id/update'
      path: '/product/category/$id/update'
      fullPath: '/product/category/$id/update'
      preLoaderRoute: typeof AppProductCategoryIdUpdateImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/settings/team/$id/edit': {
      id: '/_app/settings/team/$id/edit'
      path: '/team/$id/edit'
      fullPath: '/settings/team/$id/edit'
      preLoaderRoute: typeof AppSettingsTeamIdEditImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/user/$id/edit': {
      id: '/_app/settings/user/$id/edit'
      path: '/user/$id/edit'
      fullPath: '/settings/user/$id/edit'
      preLoaderRoute: typeof AppSettingsUserIdEditImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/inventory/category/$id/': {
      id: '/_app/inventory/category/$id/'
      path: '/inventory/category/$id'
      fullPath: '/inventory/category/$id'
      preLoaderRoute: typeof AppInventoryCategoryIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/master/$id/': {
      id: '/_app/inventory/master/$id/'
      path: '/inventory/master/$id'
      fullPath: '/inventory/master/$id'
      preLoaderRoute: typeof AppInventoryMasterIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/inventory/supplier/$id/': {
      id: '/_app/inventory/supplier/$id/'
      path: '/inventory/supplier/$id'
      fullPath: '/inventory/supplier/$id'
      preLoaderRoute: typeof AppInventorySupplierIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/settings/user/$id/': {
      id: '/_app/settings/user/$id/'
      path: '/user/$id'
      fullPath: '/settings/user/$id'
      preLoaderRoute: typeof AppSettingsUserIdIndexImport
      parentRoute: typeof AppSettingsRouteImport
    }
  }
}

// Create and export the route tree

interface AppOutletPosRouteRouteChildren {
  AppOutletPosPosidRoute: typeof AppOutletPosPosidRoute
  AppOutletPosCreateRoute: typeof AppOutletPosCreateRoute
  AppOutletPosIndexRoute: typeof AppOutletPosIndexRoute
}

const AppOutletPosRouteRouteChildren: AppOutletPosRouteRouteChildren = {
  AppOutletPosPosidRoute: AppOutletPosPosidRoute,
  AppOutletPosCreateRoute: AppOutletPosCreateRoute,
  AppOutletPosIndexRoute: AppOutletPosIndexRoute,
}

const AppOutletPosRouteRouteWithChildren =
  AppOutletPosRouteRoute._addFileChildren(AppOutletPosRouteRouteChildren)

interface AppOutletStaffRouteRouteChildren {
  AppOutletStaffAddRoute: typeof AppOutletStaffAddRoute
  AppOutletStaffIndexRoute: typeof AppOutletStaffIndexRoute
}

const AppOutletStaffRouteRouteChildren: AppOutletStaffRouteRouteChildren = {
  AppOutletStaffAddRoute: AppOutletStaffAddRoute,
  AppOutletStaffIndexRoute: AppOutletStaffIndexRoute,
}

const AppOutletStaffRouteRouteWithChildren =
  AppOutletStaffRouteRoute._addFileChildren(AppOutletStaffRouteRouteChildren)

interface AppOutletRouteRouteChildren {
  AppOutletPosRouteRoute: typeof AppOutletPosRouteRouteWithChildren
  AppOutletStaffRouteRoute: typeof AppOutletStaffRouteRouteWithChildren
  AppOutletIndexRoute: typeof AppOutletIndexRoute
  AppOutletPaymentIndexRoute: typeof AppOutletPaymentIndexRoute
  AppOutletSalesChannelIndexRoute: typeof AppOutletSalesChannelIndexRoute
}

const AppOutletRouteRouteChildren: AppOutletRouteRouteChildren = {
  AppOutletPosRouteRoute: AppOutletPosRouteRouteWithChildren,
  AppOutletStaffRouteRoute: AppOutletStaffRouteRouteWithChildren,
  AppOutletIndexRoute: AppOutletIndexRoute,
  AppOutletPaymentIndexRoute: AppOutletPaymentIndexRoute,
  AppOutletSalesChannelIndexRoute: AppOutletSalesChannelIndexRoute,
}

const AppOutletRouteRouteWithChildren = AppOutletRouteRoute._addFileChildren(
  AppOutletRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsOutletIdRoute: typeof AppSettingsOutletIdRoute
  AppSettingsOutletCreateRoute: typeof AppSettingsOutletCreateRoute
  AppSettingsTeamCreateRoute: typeof AppSettingsTeamCreateRoute
  AppSettingsUserCreateRoute: typeof AppSettingsUserCreateRoute
  AppSettingsOutletIndexRoute: typeof AppSettingsOutletIndexRoute
  AppSettingsTeamIndexRoute: typeof AppSettingsTeamIndexRoute
  AppSettingsUserIndexRoute: typeof AppSettingsUserIndexRoute
  AppSettingsTeamIdEditRoute: typeof AppSettingsTeamIdEditRoute
  AppSettingsUserIdEditRoute: typeof AppSettingsUserIdEditRoute
  AppSettingsUserIdIndexRoute: typeof AppSettingsUserIdIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsOutletIdRoute: AppSettingsOutletIdRoute,
  AppSettingsOutletCreateRoute: AppSettingsOutletCreateRoute,
  AppSettingsTeamCreateRoute: AppSettingsTeamCreateRoute,
  AppSettingsUserCreateRoute: AppSettingsUserCreateRoute,
  AppSettingsOutletIndexRoute: AppSettingsOutletIndexRoute,
  AppSettingsTeamIndexRoute: AppSettingsTeamIndexRoute,
  AppSettingsUserIndexRoute: AppSettingsUserIndexRoute,
  AppSettingsTeamIdEditRoute: AppSettingsTeamIdEditRoute,
  AppSettingsUserIdEditRoute: AppSettingsUserIdEditRoute,
  AppSettingsUserIdIndexRoute: AppSettingsUserIdIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppOutletRouteRoute: typeof AppOutletRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppInventorySplatRoute: typeof AppInventorySplatRoute
  AppProductCreateRoute: typeof AppProductCreateRoute
  AppReportCashFlowRoute: typeof AppReportCashFlowRoute
  AppProductIndexRoute: typeof AppProductIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppReportIndexRoute: typeof AppReportIndexRoute
  AppSaleIndexRoute: typeof AppSaleIndexRoute
  AppInventoryCategoryCreateRoute: typeof AppInventoryCategoryCreateRoute
  AppInventoryMasterCreateRoute: typeof AppInventoryMasterCreateRoute
  AppInventoryPoCreateRoute: typeof AppInventoryPoCreateRoute
  AppInventorySupplierCreateRoute: typeof AppInventorySupplierCreateRoute
  AppInventoryUnitIdRoute: typeof AppInventoryUnitIdRoute
  AppInventoryUnitCreateRoute: typeof AppInventoryUnitCreateRoute
  AppProductIdRecipeRoute: typeof AppProductIdRecipeRoute
  AppProductIdUpdateRoute: typeof AppProductIdUpdateRoute
  AppProductCategoryCreateRoute: typeof AppProductCategoryCreateRoute
  AppInventoryCategoryIndexRoute: typeof AppInventoryCategoryIndexRoute
  AppInventoryMasterIndexRoute: typeof AppInventoryMasterIndexRoute
  AppInventoryPoIndexRoute: typeof AppInventoryPoIndexRoute
  AppInventoryStockIndexRoute: typeof AppInventoryStockIndexRoute
  AppInventorySupplierIndexRoute: typeof AppInventorySupplierIndexRoute
  AppInventoryUnitIndexRoute: typeof AppInventoryUnitIndexRoute
  AppProductIdIndexRoute: typeof AppProductIdIndexRoute
  AppProductCategoryIndexRoute: typeof AppProductCategoryIndexRoute
  AppReportSalesIndexRoute: typeof AppReportSalesIndexRoute
  AppInventoryCategoryIdEditRoute: typeof AppInventoryCategoryIdEditRoute
  AppInventoryMasterIdEditRoute: typeof AppInventoryMasterIdEditRoute
  AppInventoryMasterIdRecipeRoute: typeof AppInventoryMasterIdRecipeRoute
  AppInventorySupplierIdEditRoute: typeof AppInventorySupplierIdEditRoute
  AppProductCategoryIdUpdateRoute: typeof AppProductCategoryIdUpdateRoute
  AppInventoryCategoryIdIndexRoute: typeof AppInventoryCategoryIdIndexRoute
  AppInventoryMasterIdIndexRoute: typeof AppInventoryMasterIdIndexRoute
  AppInventorySupplierIdIndexRoute: typeof AppInventorySupplierIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppOutletRouteRoute: AppOutletRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppInventorySplatRoute: AppInventorySplatRoute,
  AppProductCreateRoute: AppProductCreateRoute,
  AppReportCashFlowRoute: AppReportCashFlowRoute,
  AppProductIndexRoute: AppProductIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppReportIndexRoute: AppReportIndexRoute,
  AppSaleIndexRoute: AppSaleIndexRoute,
  AppInventoryCategoryCreateRoute: AppInventoryCategoryCreateRoute,
  AppInventoryMasterCreateRoute: AppInventoryMasterCreateRoute,
  AppInventoryPoCreateRoute: AppInventoryPoCreateRoute,
  AppInventorySupplierCreateRoute: AppInventorySupplierCreateRoute,
  AppInventoryUnitIdRoute: AppInventoryUnitIdRoute,
  AppInventoryUnitCreateRoute: AppInventoryUnitCreateRoute,
  AppProductIdRecipeRoute: AppProductIdRecipeRoute,
  AppProductIdUpdateRoute: AppProductIdUpdateRoute,
  AppProductCategoryCreateRoute: AppProductCategoryCreateRoute,
  AppInventoryCategoryIndexRoute: AppInventoryCategoryIndexRoute,
  AppInventoryMasterIndexRoute: AppInventoryMasterIndexRoute,
  AppInventoryPoIndexRoute: AppInventoryPoIndexRoute,
  AppInventoryStockIndexRoute: AppInventoryStockIndexRoute,
  AppInventorySupplierIndexRoute: AppInventorySupplierIndexRoute,
  AppInventoryUnitIndexRoute: AppInventoryUnitIndexRoute,
  AppProductIdIndexRoute: AppProductIdIndexRoute,
  AppProductCategoryIndexRoute: AppProductCategoryIndexRoute,
  AppReportSalesIndexRoute: AppReportSalesIndexRoute,
  AppInventoryCategoryIdEditRoute: AppInventoryCategoryIdEditRoute,
  AppInventoryMasterIdEditRoute: AppInventoryMasterIdEditRoute,
  AppInventoryMasterIdRecipeRoute: AppInventoryMasterIdRecipeRoute,
  AppInventorySupplierIdEditRoute: AppInventorySupplierIdEditRoute,
  AppProductCategoryIdUpdateRoute: AppProductCategoryIdUpdateRoute,
  AppInventoryCategoryIdIndexRoute: AppInventoryCategoryIdIndexRoute,
  AppInventoryMasterIdIndexRoute: AppInventoryMasterIdIndexRoute,
  AppInventorySupplierIdIndexRoute: AppInventorySupplierIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/outlet': typeof AppOutletRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/': typeof AppIndexRoute
  '/outlet/pos': typeof AppOutletPosRouteRouteWithChildren
  '/outlet/staff': typeof AppOutletStaffRouteRouteWithChildren
  '/inventory/$': typeof AppInventorySplatRoute
  '/product/create': typeof AppProductCreateRoute
  '/report/cash-flow': typeof AppReportCashFlowRoute
  '/outlet/': typeof AppOutletIndexRoute
  '/product': typeof AppProductIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/report': typeof AppReportIndexRoute
  '/sale': typeof AppSaleIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/inventory/category/create': typeof AppInventoryCategoryCreateRoute
  '/inventory/master/create': typeof AppInventoryMasterCreateRoute
  '/inventory/po/create': typeof AppInventoryPoCreateRoute
  '/inventory/supplier/create': typeof AppInventorySupplierCreateRoute
  '/inventory/unit/$id': typeof AppInventoryUnitIdRoute
  '/inventory/unit/create': typeof AppInventoryUnitCreateRoute
  '/outlet/pos/$posid': typeof AppOutletPosPosidRoute
  '/outlet/pos/create': typeof AppOutletPosCreateRoute
  '/outlet/staff/add': typeof AppOutletStaffAddRoute
  '/product/$id/recipe': typeof AppProductIdRecipeRoute
  '/product/$id/update': typeof AppProductIdUpdateRoute
  '/product/category/create': typeof AppProductCategoryCreateRoute
  '/settings/outlet/$id': typeof AppSettingsOutletIdRoute
  '/settings/outlet/create': typeof AppSettingsOutletCreateRoute
  '/settings/team/create': typeof AppSettingsTeamCreateRoute
  '/settings/user/create': typeof AppSettingsUserCreateRoute
  '/inventory/category': typeof AppInventoryCategoryIndexRoute
  '/inventory/master': typeof AppInventoryMasterIndexRoute
  '/inventory/po': typeof AppInventoryPoIndexRoute
  '/inventory/stock': typeof AppInventoryStockIndexRoute
  '/inventory/supplier': typeof AppInventorySupplierIndexRoute
  '/inventory/unit': typeof AppInventoryUnitIndexRoute
  '/outlet/payment': typeof AppOutletPaymentIndexRoute
  '/outlet/pos/': typeof AppOutletPosIndexRoute
  '/outlet/sales-channel': typeof AppOutletSalesChannelIndexRoute
  '/outlet/staff/': typeof AppOutletStaffIndexRoute
  '/product/$id': typeof AppProductIdIndexRoute
  '/product/category': typeof AppProductCategoryIndexRoute
  '/report/sales': typeof AppReportSalesIndexRoute
  '/settings/outlet': typeof AppSettingsOutletIndexRoute
  '/settings/team': typeof AppSettingsTeamIndexRoute
  '/settings/user': typeof AppSettingsUserIndexRoute
  '/inventory/category/$id/edit': typeof AppInventoryCategoryIdEditRoute
  '/inventory/master/$id/edit': typeof AppInventoryMasterIdEditRoute
  '/inventory/master/$id/recipe': typeof AppInventoryMasterIdRecipeRoute
  '/inventory/supplier/$id/edit': typeof AppInventorySupplierIdEditRoute
  '/product/category/$id/update': typeof AppProductCategoryIdUpdateRoute
  '/settings/team/$id/edit': typeof AppSettingsTeamIdEditRoute
  '/settings/user/$id/edit': typeof AppSettingsUserIdEditRoute
  '/inventory/category/$id': typeof AppInventoryCategoryIdIndexRoute
  '/inventory/master/$id': typeof AppInventoryMasterIdIndexRoute
  '/inventory/supplier/$id': typeof AppInventorySupplierIdIndexRoute
  '/settings/user/$id': typeof AppSettingsUserIdIndexRoute
}

export interface FileRoutesByTo {
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/': typeof AppIndexRoute
  '/inventory/$': typeof AppInventorySplatRoute
  '/product/create': typeof AppProductCreateRoute
  '/report/cash-flow': typeof AppReportCashFlowRoute
  '/outlet': typeof AppOutletIndexRoute
  '/product': typeof AppProductIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/report': typeof AppReportIndexRoute
  '/sale': typeof AppSaleIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/inventory/category/create': typeof AppInventoryCategoryCreateRoute
  '/inventory/master/create': typeof AppInventoryMasterCreateRoute
  '/inventory/po/create': typeof AppInventoryPoCreateRoute
  '/inventory/supplier/create': typeof AppInventorySupplierCreateRoute
  '/inventory/unit/$id': typeof AppInventoryUnitIdRoute
  '/inventory/unit/create': typeof AppInventoryUnitCreateRoute
  '/outlet/pos/$posid': typeof AppOutletPosPosidRoute
  '/outlet/pos/create': typeof AppOutletPosCreateRoute
  '/outlet/staff/add': typeof AppOutletStaffAddRoute
  '/product/$id/recipe': typeof AppProductIdRecipeRoute
  '/product/$id/update': typeof AppProductIdUpdateRoute
  '/product/category/create': typeof AppProductCategoryCreateRoute
  '/settings/outlet/$id': typeof AppSettingsOutletIdRoute
  '/settings/outlet/create': typeof AppSettingsOutletCreateRoute
  '/settings/team/create': typeof AppSettingsTeamCreateRoute
  '/settings/user/create': typeof AppSettingsUserCreateRoute
  '/inventory/category': typeof AppInventoryCategoryIndexRoute
  '/inventory/master': typeof AppInventoryMasterIndexRoute
  '/inventory/po': typeof AppInventoryPoIndexRoute
  '/inventory/stock': typeof AppInventoryStockIndexRoute
  '/inventory/supplier': typeof AppInventorySupplierIndexRoute
  '/inventory/unit': typeof AppInventoryUnitIndexRoute
  '/outlet/payment': typeof AppOutletPaymentIndexRoute
  '/outlet/pos': typeof AppOutletPosIndexRoute
  '/outlet/sales-channel': typeof AppOutletSalesChannelIndexRoute
  '/outlet/staff': typeof AppOutletStaffIndexRoute
  '/product/$id': typeof AppProductIdIndexRoute
  '/product/category': typeof AppProductCategoryIndexRoute
  '/report/sales': typeof AppReportSalesIndexRoute
  '/settings/outlet': typeof AppSettingsOutletIndexRoute
  '/settings/team': typeof AppSettingsTeamIndexRoute
  '/settings/user': typeof AppSettingsUserIndexRoute
  '/inventory/category/$id/edit': typeof AppInventoryCategoryIdEditRoute
  '/inventory/master/$id/edit': typeof AppInventoryMasterIdEditRoute
  '/inventory/master/$id/recipe': typeof AppInventoryMasterIdRecipeRoute
  '/inventory/supplier/$id/edit': typeof AppInventorySupplierIdEditRoute
  '/product/category/$id/update': typeof AppProductCategoryIdUpdateRoute
  '/settings/team/$id/edit': typeof AppSettingsTeamIdEditRoute
  '/settings/user/$id/edit': typeof AppSettingsUserIdEditRoute
  '/inventory/category/$id': typeof AppInventoryCategoryIdIndexRoute
  '/inventory/master/$id': typeof AppInventoryMasterIdIndexRoute
  '/inventory/supplier/$id': typeof AppInventorySupplierIdIndexRoute
  '/settings/user/$id': typeof AppSettingsUserIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/_app/outlet': typeof AppOutletRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/_app/': typeof AppIndexRoute
  '/_app/outlet/pos': typeof AppOutletPosRouteRouteWithChildren
  '/_app/outlet/staff': typeof AppOutletStaffRouteRouteWithChildren
  '/_app/inventory/$': typeof AppInventorySplatRoute
  '/_app/product/create': typeof AppProductCreateRoute
  '/_app/report/cash-flow': typeof AppReportCashFlowRoute
  '/_app/outlet/': typeof AppOutletIndexRoute
  '/_app/product/': typeof AppProductIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/report/': typeof AppReportIndexRoute
  '/_app/sale/': typeof AppSaleIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/inventory/category/create': typeof AppInventoryCategoryCreateRoute
  '/_app/inventory/master/create': typeof AppInventoryMasterCreateRoute
  '/_app/inventory/po/create': typeof AppInventoryPoCreateRoute
  '/_app/inventory/supplier/create': typeof AppInventorySupplierCreateRoute
  '/_app/inventory/unit/$id': typeof AppInventoryUnitIdRoute
  '/_app/inventory/unit/create': typeof AppInventoryUnitCreateRoute
  '/_app/outlet/pos/$posid': typeof AppOutletPosPosidRoute
  '/_app/outlet/pos/create': typeof AppOutletPosCreateRoute
  '/_app/outlet/staff/add': typeof AppOutletStaffAddRoute
  '/_app/product/$id/recipe': typeof AppProductIdRecipeRoute
  '/_app/product/$id/update': typeof AppProductIdUpdateRoute
  '/_app/product/category/create': typeof AppProductCategoryCreateRoute
  '/_app/settings/outlet/$id': typeof AppSettingsOutletIdRoute
  '/_app/settings/outlet/create': typeof AppSettingsOutletCreateRoute
  '/_app/settings/team/create': typeof AppSettingsTeamCreateRoute
  '/_app/settings/user/create': typeof AppSettingsUserCreateRoute
  '/_app/inventory/category/': typeof AppInventoryCategoryIndexRoute
  '/_app/inventory/master/': typeof AppInventoryMasterIndexRoute
  '/_app/inventory/po/': typeof AppInventoryPoIndexRoute
  '/_app/inventory/stock/': typeof AppInventoryStockIndexRoute
  '/_app/inventory/supplier/': typeof AppInventorySupplierIndexRoute
  '/_app/inventory/unit/': typeof AppInventoryUnitIndexRoute
  '/_app/outlet/payment/': typeof AppOutletPaymentIndexRoute
  '/_app/outlet/pos/': typeof AppOutletPosIndexRoute
  '/_app/outlet/sales-channel/': typeof AppOutletSalesChannelIndexRoute
  '/_app/outlet/staff/': typeof AppOutletStaffIndexRoute
  '/_app/product/$id/': typeof AppProductIdIndexRoute
  '/_app/product/category/': typeof AppProductCategoryIndexRoute
  '/_app/report/sales/': typeof AppReportSalesIndexRoute
  '/_app/settings/outlet/': typeof AppSettingsOutletIndexRoute
  '/_app/settings/team/': typeof AppSettingsTeamIndexRoute
  '/_app/settings/user/': typeof AppSettingsUserIndexRoute
  '/_app/inventory/category/$id/edit': typeof AppInventoryCategoryIdEditRoute
  '/_app/inventory/master/$id/edit': typeof AppInventoryMasterIdEditRoute
  '/_app/inventory/master/$id/recipe': typeof AppInventoryMasterIdRecipeRoute
  '/_app/inventory/supplier/$id/edit': typeof AppInventorySupplierIdEditRoute
  '/_app/product/category/$id/update': typeof AppProductCategoryIdUpdateRoute
  '/_app/settings/team/$id/edit': typeof AppSettingsTeamIdEditRoute
  '/_app/settings/user/$id/edit': typeof AppSettingsUserIdEditRoute
  '/_app/inventory/category/$id/': typeof AppInventoryCategoryIdIndexRoute
  '/_app/inventory/master/$id/': typeof AppInventoryMasterIdIndexRoute
  '/_app/inventory/supplier/$id/': typeof AppInventorySupplierIdIndexRoute
  '/_app/settings/user/$id/': typeof AppSettingsUserIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/auth'
    | '/outlet'
    | '/settings'
    | '/auth/login'
    | '/'
    | '/outlet/pos'
    | '/outlet/staff'
    | '/inventory/$'
    | '/product/create'
    | '/report/cash-flow'
    | '/outlet/'
    | '/product'
    | '/profile'
    | '/report'
    | '/sale'
    | '/settings/'
    | '/inventory/category/create'
    | '/inventory/master/create'
    | '/inventory/po/create'
    | '/inventory/supplier/create'
    | '/inventory/unit/$id'
    | '/inventory/unit/create'
    | '/outlet/pos/$posid'
    | '/outlet/pos/create'
    | '/outlet/staff/add'
    | '/product/$id/recipe'
    | '/product/$id/update'
    | '/product/category/create'
    | '/settings/outlet/$id'
    | '/settings/outlet/create'
    | '/settings/team/create'
    | '/settings/user/create'
    | '/inventory/category'
    | '/inventory/master'
    | '/inventory/po'
    | '/inventory/stock'
    | '/inventory/supplier'
    | '/inventory/unit'
    | '/outlet/payment'
    | '/outlet/pos/'
    | '/outlet/sales-channel'
    | '/outlet/staff/'
    | '/product/$id'
    | '/product/category'
    | '/report/sales'
    | '/settings/outlet'
    | '/settings/team'
    | '/settings/user'
    | '/inventory/category/$id/edit'
    | '/inventory/master/$id/edit'
    | '/inventory/master/$id/recipe'
    | '/inventory/supplier/$id/edit'
    | '/product/category/$id/update'
    | '/settings/team/$id/edit'
    | '/settings/user/$id/edit'
    | '/inventory/category/$id'
    | '/inventory/master/$id'
    | '/inventory/supplier/$id'
    | '/settings/user/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/auth/login'
    | '/'
    | '/inventory/$'
    | '/product/create'
    | '/report/cash-flow'
    | '/outlet'
    | '/product'
    | '/profile'
    | '/report'
    | '/sale'
    | '/settings'
    | '/inventory/category/create'
    | '/inventory/master/create'
    | '/inventory/po/create'
    | '/inventory/supplier/create'
    | '/inventory/unit/$id'
    | '/inventory/unit/create'
    | '/outlet/pos/$posid'
    | '/outlet/pos/create'
    | '/outlet/staff/add'
    | '/product/$id/recipe'
    | '/product/$id/update'
    | '/product/category/create'
    | '/settings/outlet/$id'
    | '/settings/outlet/create'
    | '/settings/team/create'
    | '/settings/user/create'
    | '/inventory/category'
    | '/inventory/master'
    | '/inventory/po'
    | '/inventory/stock'
    | '/inventory/supplier'
    | '/inventory/unit'
    | '/outlet/payment'
    | '/outlet/pos'
    | '/outlet/sales-channel'
    | '/outlet/staff'
    | '/product/$id'
    | '/product/category'
    | '/report/sales'
    | '/settings/outlet'
    | '/settings/team'
    | '/settings/user'
    | '/inventory/category/$id/edit'
    | '/inventory/master/$id/edit'
    | '/inventory/master/$id/recipe'
    | '/inventory/supplier/$id/edit'
    | '/product/category/$id/update'
    | '/settings/team/$id/edit'
    | '/settings/user/$id/edit'
    | '/inventory/category/$id'
    | '/inventory/master/$id'
    | '/inventory/supplier/$id'
    | '/settings/user/$id'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/_app/outlet'
    | '/_app/settings'
    | '/auth/login'
    | '/_app/'
    | '/_app/outlet/pos'
    | '/_app/outlet/staff'
    | '/_app/inventory/$'
    | '/_app/product/create'
    | '/_app/report/cash-flow'
    | '/_app/outlet/'
    | '/_app/product/'
    | '/_app/profile/'
    | '/_app/report/'
    | '/_app/sale/'
    | '/_app/settings/'
    | '/_app/inventory/category/create'
    | '/_app/inventory/master/create'
    | '/_app/inventory/po/create'
    | '/_app/inventory/supplier/create'
    | '/_app/inventory/unit/$id'
    | '/_app/inventory/unit/create'
    | '/_app/outlet/pos/$posid'
    | '/_app/outlet/pos/create'
    | '/_app/outlet/staff/add'
    | '/_app/product/$id/recipe'
    | '/_app/product/$id/update'
    | '/_app/product/category/create'
    | '/_app/settings/outlet/$id'
    | '/_app/settings/outlet/create'
    | '/_app/settings/team/create'
    | '/_app/settings/user/create'
    | '/_app/inventory/category/'
    | '/_app/inventory/master/'
    | '/_app/inventory/po/'
    | '/_app/inventory/stock/'
    | '/_app/inventory/supplier/'
    | '/_app/inventory/unit/'
    | '/_app/outlet/payment/'
    | '/_app/outlet/pos/'
    | '/_app/outlet/sales-channel/'
    | '/_app/outlet/staff/'
    | '/_app/product/$id/'
    | '/_app/product/category/'
    | '/_app/report/sales/'
    | '/_app/settings/outlet/'
    | '/_app/settings/team/'
    | '/_app/settings/user/'
    | '/_app/inventory/category/$id/edit'
    | '/_app/inventory/master/$id/edit'
    | '/_app/inventory/master/$id/recipe'
    | '/_app/inventory/supplier/$id/edit'
    | '/_app/product/category/$id/update'
    | '/_app/settings/team/$id/edit'
    | '/_app/settings/user/$id/edit'
    | '/_app/inventory/category/$id/'
    | '/_app/inventory/master/$id/'
    | '/_app/inventory/supplier/$id/'
    | '/_app/settings/user/$id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/auth"
      ]
    },
    "/_app": {
      "filePath": "_app/route.tsx",
      "children": [
        "/_app/outlet",
        "/_app/settings",
        "/_app/",
        "/_app/inventory/$",
        "/_app/product/create",
        "/_app/report/cash-flow",
        "/_app/product/",
        "/_app/profile/",
        "/_app/report/",
        "/_app/sale/",
        "/_app/inventory/category/create",
        "/_app/inventory/master/create",
        "/_app/inventory/po/create",
        "/_app/inventory/supplier/create",
        "/_app/inventory/unit/$id",
        "/_app/inventory/unit/create",
        "/_app/product/$id/recipe",
        "/_app/product/$id/update",
        "/_app/product/category/create",
        "/_app/inventory/category/",
        "/_app/inventory/master/",
        "/_app/inventory/po/",
        "/_app/inventory/stock/",
        "/_app/inventory/supplier/",
        "/_app/inventory/unit/",
        "/_app/product/$id/",
        "/_app/product/category/",
        "/_app/report/sales/",
        "/_app/inventory/category/$id/edit",
        "/_app/inventory/master/$id/edit",
        "/_app/inventory/master/$id/recipe",
        "/_app/inventory/supplier/$id/edit",
        "/_app/product/category/$id/update",
        "/_app/inventory/category/$id/",
        "/_app/inventory/master/$id/",
        "/_app/inventory/supplier/$id/"
      ]
    },
    "/auth": {
      "filePath": "auth/route.tsx",
      "children": [
        "/auth/login"
      ]
    },
    "/_app/outlet": {
      "filePath": "_app/outlet/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/outlet/pos",
        "/_app/outlet/staff",
        "/_app/outlet/",
        "/_app/outlet/payment/",
        "/_app/outlet/sales-channel/"
      ]
    },
    "/_app/settings": {
      "filePath": "_app/settings/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/settings/",
        "/_app/settings/outlet/$id",
        "/_app/settings/outlet/create",
        "/_app/settings/team/create",
        "/_app/settings/user/create",
        "/_app/settings/outlet/",
        "/_app/settings/team/",
        "/_app/settings/user/",
        "/_app/settings/team/$id/edit",
        "/_app/settings/user/$id/edit",
        "/_app/settings/user/$id/"
      ]
    },
    "/auth/login": {
      "filePath": "auth/login.tsx",
      "parent": "/auth"
    },
    "/_app/": {
      "filePath": "_app/index.tsx",
      "parent": "/_app"
    },
    "/_app/outlet/pos": {
      "filePath": "_app/outlet/pos/route.tsx",
      "parent": "/_app/outlet",
      "children": [
        "/_app/outlet/pos/$posid",
        "/_app/outlet/pos/create",
        "/_app/outlet/pos/"
      ]
    },
    "/_app/outlet/staff": {
      "filePath": "_app/outlet/staff/route.tsx",
      "parent": "/_app/outlet",
      "children": [
        "/_app/outlet/staff/add",
        "/_app/outlet/staff/"
      ]
    },
    "/_app/inventory/$": {
      "filePath": "_app/inventory/$.tsx",
      "parent": "/_app"
    },
    "/_app/product/create": {
      "filePath": "_app/product/create.tsx",
      "parent": "/_app"
    },
    "/_app/report/cash-flow": {
      "filePath": "_app/report/cash-flow.tsx",
      "parent": "/_app"
    },
    "/_app/outlet/": {
      "filePath": "_app/outlet/index.tsx",
      "parent": "/_app/outlet"
    },
    "/_app/product/": {
      "filePath": "_app/product/index.tsx",
      "parent": "/_app"
    },
    "/_app/profile/": {
      "filePath": "_app/profile/index.tsx",
      "parent": "/_app"
    },
    "/_app/report/": {
      "filePath": "_app/report/index.tsx",
      "parent": "/_app"
    },
    "/_app/sale/": {
      "filePath": "_app/sale/index.tsx",
      "parent": "/_app"
    },
    "/_app/settings/": {
      "filePath": "_app/settings/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/inventory/category/create": {
      "filePath": "_app/inventory/category/create.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/master/create": {
      "filePath": "_app/inventory/master/create.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/po/create": {
      "filePath": "_app/inventory/po/create.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/supplier/create": {
      "filePath": "_app/inventory/supplier/create.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/unit/$id": {
      "filePath": "_app/inventory/unit/$id.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/unit/create": {
      "filePath": "_app/inventory/unit/create.tsx",
      "parent": "/_app"
    },
    "/_app/outlet/pos/$posid": {
      "filePath": "_app/outlet/pos/$posid.tsx",
      "parent": "/_app/outlet/pos"
    },
    "/_app/outlet/pos/create": {
      "filePath": "_app/outlet/pos/create.tsx",
      "parent": "/_app/outlet/pos"
    },
    "/_app/outlet/staff/add": {
      "filePath": "_app/outlet/staff/add.tsx",
      "parent": "/_app/outlet/staff"
    },
    "/_app/product/$id/recipe": {
      "filePath": "_app/product/$id.recipe.tsx",
      "parent": "/_app"
    },
    "/_app/product/$id/update": {
      "filePath": "_app/product/$id.update.tsx",
      "parent": "/_app"
    },
    "/_app/product/category/create": {
      "filePath": "_app/product/category/create.tsx",
      "parent": "/_app"
    },
    "/_app/settings/outlet/$id": {
      "filePath": "_app/settings/outlet/$id.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/outlet/create": {
      "filePath": "_app/settings/outlet/create.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/team/create": {
      "filePath": "_app/settings/team/create.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/user/create": {
      "filePath": "_app/settings/user/create.tsx",
      "parent": "/_app/settings"
    },
    "/_app/inventory/category/": {
      "filePath": "_app/inventory/category/index.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/master/": {
      "filePath": "_app/inventory/master/index.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/po/": {
      "filePath": "_app/inventory/po/index.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/stock/": {
      "filePath": "_app/inventory/stock/index.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/supplier/": {
      "filePath": "_app/inventory/supplier/index.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/unit/": {
      "filePath": "_app/inventory/unit/index.tsx",
      "parent": "/_app"
    },
    "/_app/outlet/payment/": {
      "filePath": "_app/outlet/payment/index.tsx",
      "parent": "/_app/outlet"
    },
    "/_app/outlet/pos/": {
      "filePath": "_app/outlet/pos/index.tsx",
      "parent": "/_app/outlet/pos"
    },
    "/_app/outlet/sales-channel/": {
      "filePath": "_app/outlet/sales-channel/index.tsx",
      "parent": "/_app/outlet"
    },
    "/_app/outlet/staff/": {
      "filePath": "_app/outlet/staff/index.tsx",
      "parent": "/_app/outlet/staff"
    },
    "/_app/product/$id/": {
      "filePath": "_app/product/$id.index.tsx",
      "parent": "/_app"
    },
    "/_app/product/category/": {
      "filePath": "_app/product/category/index.tsx",
      "parent": "/_app"
    },
    "/_app/report/sales/": {
      "filePath": "_app/report/sales/index.tsx",
      "parent": "/_app"
    },
    "/_app/settings/outlet/": {
      "filePath": "_app/settings/outlet/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/team/": {
      "filePath": "_app/settings/team/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/user/": {
      "filePath": "_app/settings/user/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/inventory/category/$id/edit": {
      "filePath": "_app/inventory/category/$id.edit.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/master/$id/edit": {
      "filePath": "_app/inventory/master/$id.edit.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/master/$id/recipe": {
      "filePath": "_app/inventory/master/$id.recipe.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/supplier/$id/edit": {
      "filePath": "_app/inventory/supplier/$id.edit.tsx",
      "parent": "/_app"
    },
    "/_app/product/category/$id/update": {
      "filePath": "_app/product/category/$id.update.tsx",
      "parent": "/_app"
    },
    "/_app/settings/team/$id/edit": {
      "filePath": "_app/settings/team/$id.edit.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/user/$id/edit": {
      "filePath": "_app/settings/user/$id.edit.tsx",
      "parent": "/_app/settings"
    },
    "/_app/inventory/category/$id/": {
      "filePath": "_app/inventory/category/$id.index.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/master/$id/": {
      "filePath": "_app/inventory/master/$id.index.tsx",
      "parent": "/_app"
    },
    "/_app/inventory/supplier/$id/": {
      "filePath": "_app/inventory/supplier/$id.index.tsx",
      "parent": "/_app"
    },
    "/_app/settings/user/$id/": {
      "filePath": "_app/settings/user/$id.index.tsx",
      "parent": "/_app/settings"
    }
  }
}
ROUTE_MANIFEST_END */
